<template>
  <nav
    id="main-nav"
    class="fixed zindex w-full px-4"
    :class="{
      'bg-transparent mt-1 navi-ssc': !isScrolled,
      'shadow-lg navi-sticky': isScrolled
    }"
  >
    <div class="container mx-auto">
      <div class="flex justify-between items-center py-4">
        <!-- Logo -->
        <div class="flex items-center">
          <div
            class="h-10 text-primary rounded-full flex items-center justify-center mr-3 logo"
          >
            <img width="260" src="@/assets/web_logo.png" alt="" />
          </div>
          <!-- <a href="#" class="text-xl font-bold text-white">codevibrant</a> -->
        </div>

        <!-- Desktop Navigation and CTA Button - Aligned Together -->
        <div class="hidden md:flex items-center space-x-8">
          <!-- Navigation Links -->
          <div class="flex space-x-8">
            <span
              v-for="(item, index) in navItems"
              :key="index"
              @click="onNaiItemClick(index)"
              class="text-white hover:text-[#333] font-medium transition-all cursor-pointer"
              :class="naviIndex === index ? 'navi-active' : ''"
              >{{ item.title }}</span
            >
          </div>

          <!-- CTA Button -->
          <div>
            <!-- <a
              href="#"
              class="px-6 py-2 bg-white text-primary font-semibold rounded-lg hover:bg-gray-100 transition-all"
            >
            </a> -->

            <a href="https://www.youtube.com/@DEERGIFTSCOLTD" target="_blank"
              ><i class="fa-brands fa-youtube fa-lg" style="color: #fff"></i
            ></a>
            <a
              href="https://www.facebook.com/Deergifts.CassieLee/"
              target="_blank"
            >
              <i
                class="fa-brands fa-facebook ml-3 fa-lg"
                style="color: #fff"
              ></i>
            </a>

            <a
              href="https://www.magnific.com/premium-vector/vinnytsia-ukraine-april-29-2023-popular-social-media-logo-icon-linkedin-vector-design-realistic-editorial-sign_42726738.htm#fromView=detail&position=4&uuid=aa2e1a54-3d2b-4271-b77a-65b10d4ad3ae&track=ais_hybrid&from_element=cross_selling__vector"
              target="_blank"
            >
              <i
                class="fa-brands fa-linkedin ml-3 fa-lg"
                style="color: #fff"
              ></i>
            </a>
          </div>
        </div>

        <!-- Mobile Menu Button -->
        <div class="md:hidden">
          <button
            @click="toggleMobileMenu"
            class="text-white focus:outline-none"
          >
            <i class="fa fa-bars text-2xl"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Navigation -->
    <div
      v-if="showMobileMenu"
      class="md:hidden"
      :class="{
        'bg-transparent border-white/20': !isScrolled,
        'bg-primary border-white/20': isScrolled
      }"
    >
      <div class="container mx-auto px-4 py-4 space-y-4">
        <a
          href="#"
          v-for="item in navItems"
          :key="item"
          class="block text-white hover:text-primary font-medium py-2 transition-all"
          >{{ item }}</a
        >
        <a
          href="#"
          class="block w-full text-center px-6 py-2 bg-white text-primary font-semibold rounded-lg hover:bg-gray-100 transition-all"
        >
          Get Started
        </a>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'Navbar',
  components: {},
  data() {
    return {
      isScrolled: false,
      showMobileMenu: false,
      naviIndex: 0,
      // navItems: ['Home', 'Products', 'About Us', 'Contact'],
      navItems: [
        {
          title: 'Home',
          path: '/'
        },
        {
          title: 'Products',
          path: '/products'
        },
        // {
        //   title: 'About Us',
        //   path: '/aboutus'
        // },
        {
          title: 'Our History',
          path: '/our-history'
        },
        {
          title: 'Contact',
          path: '/contact'
        },
        {
          title: 'Start Your Project',
          path: '/start-your-project'
        }
      ]
    }
  },
  mounted() {
    this.$bus.$on('navi-page', (p) => {
      if (p === '/products') {
        this.naviIndex = 1
      }
    })
    window.addEventListener('scroll', this.handleScroll)
    const currPath = this.$route.path
    // if (currPath === '/products') {
    //   this.isScrolled = true
    // }
    this.excludeScroll()
    for (let i = 0; i < this.navItems.length; i++) {
      if (currPath === this.navItems[i].path) {
        this.naviIndex = i
        break
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    excludeScroll() {
      const currPath = this.$route.path
      if (currPath === '/products' || currPath === '/our-history') {
        this.isScrolled = true
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 72
      this.excludeScroll()
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    onNaiItemClick(index) {
      const currPath = this.$route.path
      const toPath = this.navItems[index].path
      if (currPath === toPath) {
        return
      }
      this.naviIndex = index
      this.$router.push(toPath)
      if (toPath === '/products' || toPath === '/our-history') {
        this.isScrolled = true
      }
    }
  }
}
</script>

<style scoped>
.zindex {
  z-index: 999;
}
.navi-ssc {
  transition: margin 0.1s ease;
}
.navi-sticky {
  background-image: linear-gradient(
    to right,
    rgba(212, 51, 93, 1),
    rgba(255, 86, 39, 1)
  );
}
.navi-sticky img {
  filter: brightness(0) invert(1);
}
.navi-active {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/header/navbar.vue